const UPDATED = "Laatst bijgewerkt: juli 2026";

export const PRIVACY = {
  label: "Juridisch",
  title: "Privacyverklaring",
  updated: UPDATED,
  sections: [
    {
      h: "Wie is verantwoordelijk voor je gegevens?",
      p: [
        "Praktijk De Kern, met praktijkadres E. Van Notenlaan 25, 2960 Sint-Lenaarts, is verantwoordelijk voor de verwerking van je persoonsgegevens zoals beschreven in deze privacyverklaring.",
        "Je kan me bereiken via info@praktijk-dekern.be of op het nummer 0496 / 43 49 95.",
      ],
    },
    {
      h: "Welke gegevens verzamel ik?",
      p: [
        "Wanneer je het contactformulier op deze website invult, verwerk ik je naam, e-mailadres, telefoonnummer (indien je dit invult), het onderwerp en de inhoud van je bericht.",
        "Ik verzamel enkel de gegevens die je zelf aan mij bezorgt.",
      ],
    },
    {
      h: "Waarom verwerk ik je gegevens?",
      p: [
        "Ik gebruik deze gegevens uitsluitend om je vraag te beantwoorden en om contact met je op te nemen.",
        "De rechtsgrond hiervoor is jouw toestemming en/of het nemen van stappen op jouw verzoek met het oog op een mogelijke begeleiding.",
      ],
    },
    {
      h: "Hoe lang bewaar ik je gegevens?",
      p: [
        "Ik bewaar je gegevens niet langer dan nodig is voor het doel waarvoor ze verzameld werden. Contactaanvragen worden verwijderd zodra ze niet langer relevant zijn.",
      ],
    },
    {
      h: "Deel ik je gegevens met derden?",
      p: [
        "Ik deel jouw persoonsgegevens niet met derden, tenzij dit noodzakelijk is voor de werking van mijn praktijk of wanneer ik hiertoe wettelijk verplicht ben.",
      ],
    },
    {
      h: "Beveiliging",
      p: [
        "Ik ga zorgvuldig om met jouw persoonsgegevens en neem passende maatregelen om deze te beschermen tegen verlies, misbruik of ongeoorloofde toegang. Ik werk uitsluitend met betrouwbare systemen en dienstverleners en streef ernaar jouw gegevens zo veilig mogelijk te bewaren.",
      ],
    },
    {
      h: "Jouw rechten",
      p: [
        "Je hebt het recht op inzage, verbetering, verwijdering, beperking van verwerking en overdraagbaarheid van je gegevens. Je kan ook bezwaar maken tegen de verwerking van je persoonsgegevens.",
        "Daarnaast kan je je toestemming op elk moment intrekken.",
        "Stuur hiervoor een e-mail naar info@praktijk-dekern.be.",
      ],
    },
    {
      h: "Cookies",
      p: [
        "Deze website maakt gebruik van cookies. Meer informatie hierover vind je in het cookiebeleid.",
      ],
      link: { text: "Naar het cookiebeleid", to: "/cookiebeleid" },
    },
    {
      h: "Wijzigingen",
      p: [
        "Ik kan deze privacyverklaring van tijd tot tijd aanpassen. De meest recente versie vind je steeds op deze pagina.",
      ],
    },
  ],
};

export const COOKIES = {
  label: "Juridisch",
  title: "Cookiebeleid",
  updated: UPDATED,
  sections: [
    {
      h: "Wat zijn cookies?",
      p: [
        "Cookies zijn kleine tekstbestanden die op je toestel worden geplaatst wanneer je een website bezoekt. Ze helpen om de website goed te laten werken en om je bezoek aangenamer te maken.",
      ],
    },
    {
      h: "Welke cookies gebruik ik?",
      p: [
        "Deze website gebruikt in de eerste plaats functionele cookies die noodzakelijk zijn om de site correct te laten werken.",
        "Wanneer je de kaart met mijn locatie laadt, kan Google Maps cookies plaatsen. Die kaart wordt pas geladen nadat je daarvoor uitdrukkelijk toestemming geeft.",
      ],
    },
    {
      h: "Je toestemming beheren",
      p: [
        "Bij je eerste bezoek vraag ik je toestemming voor niet-essentiële cookies. Je kan je keuze op elk moment aanpassen via de knop 'Cookievoorkeuren' onderaan de website, of door de cookies in je browser te wissen.",
      ],
    },
    {
      h: "Meer informatie",
      p: [
        "Wil je meer weten over hoe ik met je persoonsgegevens omga? Lees dan de privacyverklaring.",
      ],
      link: { text: "Naar de privacyverklaring", to: "/privacy" },
    },
  ],
};

export const TERMS = {
  label: "Juridisch",
  title: "Algemene voorwaarden",
  updated: UPDATED,
  sections: [
    {
      h: "Toepassing",
      p: [
        "Deze algemene voorwaarden zijn van toepassing op alle begeleiding en therapie die ik, Griet Quirynen, aanbied binnen Praktijk De Kern.",
        "Door een afspraak te maken, ga je akkoord met deze algemene voorwaarden en met het annulatiebeleid.",
      ],
    },
    {
      h: "Identificatiegegevens",
      p: [
        "Praktijk De Kern — Griet Quirynen, gezinstherapeut.",
        "Praktijkadres: E. Van Notenlaan 25, 2960 Sint-Lenaarts.",
        "E-mail: info@praktijk-dekern.be — Telefoon: 0496 / 43 49 95.",
        "Ondernemingsnummer: 1038.830.507.",
      ],
    },
    {
      h: "Mijn dienstverlening",
      p: [
        "In mijn praktijk bied ik therapie en begeleiding aan kinderen, jongeren, volwassenen en gezinnen. Samen gaan we op zoek naar inzicht, groei en mogelijke oplossingen voor de moeilijkheden waarmee je geconfronteerd wordt.",
        "Therapie en begeleiding bieden ondersteuning bij persoonlijke, emotionele en relationele moeilijkheden, maar vervangen geen medische of psychiatrische zorg wanneer die noodzakelijk is. Bij een acute crisis, een medische noodsituatie of wanneer gespecialiseerde medische of psychiatrische zorg vereist is, neem je contact op met je huisarts, behandelend arts, een spoeddienst of het noodnummer 112.",
      ],
    },
    {
      h: "Afspraken en annulatie",
      p: [
        "Afspraken worden in onderling overleg vastgelegd.",
        "Een afspraak annuleren kan kosteloos tot 48u voor je geplande afspraak, telefonisch of per sms. Indien je minder dan 48 uur op voorhand annuleert, wordt 50% van de geplande afspraak aangerekend als tegemoetkoming. Bij annuleringen binnen de 24u betaal je de volledige afspraak. Hier worden geen uitzonderingen op gemaakt.",
      ],
    },
    {
      h: "Tarieven en betaling",
      p: [
        "De actuele tarieven vind je terug op de website.",
        "Er kan contant of met Payconiq betaald worden. Gesprekken worden na iedere consultatie afgerekend.",
        "In geval van facturatie geldt een betalingstermijn van 14 dagen. Bij laattijdige betaling kunnen de wettelijke intresten en redelijke administratieve kosten worden aangerekend.",
      ],
    },
    {
      h: "Vertrouwelijkheid en beroepsgeheim",
      p: [
        "Als therapeut ben ik gebonden aan het beroepsgeheim. Alles wat tijdens de begeleiding wordt gedeeld, wordt vertrouwelijk behandeld.",
        "Ik deel geen informatie met derden zonder jouw uitdrukkelijke toestemming, behoudens de wettelijke uitzonderingen.",
      ],
    },
    {
      h: "Privacy en gegevensverwerking",
      p: [
        "Meer informatie over welke gegevens ik verzamel, waarom en hoe lang ik ze bewaar, en over jouw rechten, vind je in de privacyverklaring op deze website.",
      ],
      link: { text: "Naar de privacyverklaring", to: "/privacy" },
    },
    {
      h: "Online begeleiding",
      p: [
        "Wanneer gesprekken online plaatsvinden, gebeurt dit via een beveiligd videoplatform waarvan de link vooraf wordt bezorgd.",
        "Beide partijen zorgen voor een rustige en private omgeving en een stabiele internetverbinding. Ondanks de nodige voorzorgen kan een volledige beveiliging van digitale communicatie nooit worden gegarandeerd.",
      ],
    },
    {
      h: "Aansprakelijkheid",
      p: [
        "Ik verbind me tot een inspanningsverbintenis en niet tot een resultaatsverbintenis. Er kan geen garantie worden gegeven op een specifiek resultaat.",
        "Je blijft steeds zelf verantwoordelijk voor je eigen keuzes en beslissingen.",
      ],
    },
    {
      h: "Begeleiding van minderjarigen",
      p: [
        "Voor de begeleiding van minderjarigen kan de toestemming van de wettelijke vertegenwoordiger(s) vereist zijn.",
        "Ouders worden als partner in de begeleiding betrokken, met respect voor de vertrouwelijkheid en de veilige ruimte van het kind.",
      ],
    },
    {
      h: "Klachten",
      p: [
        "Ik vind een open en respectvolle communicatie belangrijk. Ben je om welke reden dan ook niet tevreden over mijn begeleiding of dienstverlening? Dan nodig ik je uit om dit met mij te bespreken. Vaak kunnen we in een persoonlijk gesprek samen tot een oplossing komen.",
        "Je kunt je klacht kenbaar maken via e-mail op info@praktijk-dekern.be of telefonisch via 0496 / 43 49 95. Ik neem elke klacht serieus en streef ernaar om binnen 14 kalenderdagen te reageren.",
        "Mocht het niet lukken om samen tot een oplossing te komen, dan bekijken we in onderling overleg welke verdere stappen mogelijk zijn.",
      ],
    },
    {
      h: "Toepasselijk recht",
      p: [
        "Op deze overeenkomst is uitsluitend het Belgisch recht van toepassing. Geschillen vallen onder de bevoegdheid van de rechtbanken van het gerechtelijk arrondissement Antwerpen.",
      ],
    },
  ],
};
